import React from 'react'
import { useTranslation } from 'react-i18next'
import { authenticationStore } from '~/stores'
import { BeWizrOrganizationSwitcher } from '~/ui/app/bewizr'
import { memo, observer } from '~/ui/component'
import { ClearButton, Label, Tappable, VBox } from '~/ui/components'
import { layout, useTheme } from '~/ui/styling'
import LanguageSwitcher from './LanguageSwitcher'

const AppSideBarFooter = observer('AppSideBarFooter', () => {

  const [t] = useTranslation('auth')

  const theme = useTheme()

  const oAuthProvider = authenticationStore.oAuthProvider

  const logOut = React.useCallback(() => {
    if (oAuthProvider == null) {
      authenticationStore.logOut()
    } else {
      // An oAuth logout endpoint needs to be called. Let the oAuth redirect page handle the logout.
      document.location.pathname = `/oauth/${oAuthProvider}/logout`
    }
  }, [oAuthProvider])

  //------
  // Rendering

  function render() {
    return (
      <VBox gap={layout.padding.s}>
        <LanguageSwitcher/>
        <VBox gap={layout.padding.inline.m}>
          <BeWizrOrganizationSwitcher/>
          {renderLogoutButton()}
        </VBox>
        {renderLinks()}
      </VBox>
    )
  }

  function renderLinks() {
    return (
      <VBox gap={layout.padding.inline.m}>
        <AppSideBarFooterLink
          caption={t('app:nav.privacy-and-terms')}
          href='https://be.wizr.eu/tos/'
        />
      </VBox>
    )
  }

  function renderLogoutButton() {
    return (
      <ClearButton
        onTap={logOut}
        caption={t('auth:logout.caption')}
        icon='logout'
        color={theme.fg.normal}
        small
      />
    )
  }

  return render()

})

export default AppSideBarFooter

interface AppSideBarFooterLinkProps {
  caption: string
  href:    string
}

const AppSideBarFooterLink = memo('AppSideBarFooterLink', (props: AppSideBarFooterLinkProps) => {

  const {caption, href} = props

  //------
  // Rendering

  function render() {
    return (
      <Tappable href={href} noFeedback>
        <Label
          link
          children={caption}
          truncate={false}
          small
          dim
        />
      </Tappable>
    )
  }

  return render()

})